import React, { useState } from "react"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Checkbox from "@material-ui/core/Checkbox"
import { FormElement } from "components/FormElement"
import { ICheckBoxGroupProps } from "./types"
import { StyledFormGroup } from "./style"

export const CheckBoxGroup: React.FC<ICheckBoxGroupProps> = ({
  options,
  name,
  label,
  required,
  disabled,
  extraHelperText,
  onChange,
  spacing,
  row,
  gap,
}) => {
  const [values, setValues] = useState<string[]>([])

  const updateValues = (currentValues: string[], changedValue: string, checked: boolean) =>
    checked ? [...currentValues, changedValue] : currentValues.filter(value => value !== changedValue)

  const handleChange = (value: string, checked: boolean) => {
    setValues(prevValues => updateValues(prevValues, value, checked))
    onChange?.(updateValues(values, value, checked))
  }

  const handleControllerChange = (currentValue: string[] = [], event: any, checked: boolean) => ({
    ...event,
    target: {
      value: updateValues(currentValue, event.target.value, checked),
    },
  })

  return (
    <FormElement
      name={`${name}[]`}
      label={label}
      required={required}
      disabled={disabled}
      extraHelperText={extraHelperText}
      spacing={spacing}
      inputRender={({ value: controllerValue, onChange: onControllerChange }) => (
        <StyledFormGroup row={row} gap={gap}>
          {options.map(({ label, value }, index) => (
            <FormControlLabel
              value={value}
              name={`${name}[${index}]`}
              control={
                <Checkbox
                  color="primary"
                  disabled={disabled}
                  checked={controllerValue?.includes(value)}
                  onChange={(event, checked) => {
                    onControllerChange(handleControllerChange(controllerValue, event, checked))
                    handleChange(event.target.value, checked)
                  }}
                />
              }
              key={value}
              label={label}
            />
          ))}
        </StyledFormGroup>
      )}
    />
  )
}
